// Statisk speglning av amnen_taxonomy för visning i klienten.
// Källa: migration 2026-07-03 (artikelprofil v3.1). Uppdatera om taxonomin ändras.
// Okänd slug → visas som slug (utan prefix).

export const AMNEN_LABELS: Record<string, string> = {
  statsfinanser: "Statsfinanser",
  hushallsekonomi: "Hushållsekonomi",
  arbetsmarknad: "Arbetsmarknad",
  foretagande: "Företagande",
  bostadsmarknad: "Bostadsmarknad",
  energi: "Energi",
  inflation: "Inflation",
  skatter: "Skatter",
  sjukvard: "Sjukvård",
  skola: "Skola & utbildning",
  aldreomsorg: "Äldreomsorg",
  socialforsakring: "Socialförsäkring",
  bostad: "Bostadspolitik",
  infrastruktur: "Infrastruktur",
  miljo: "Miljö & klimat",
  djurskydd: "Djurskydd",
  kriminalitet: "Kriminalitet",
  gangbrottslighet: "Gängbrottslighet",
  rattsvasende: "Rättsväsende",
  polis: "Polis",
  forsvar: "Försvar",
  sakerhetspolitik: "Säkerhetspolitik",
  terrorism: "Terrorism",
  regeringen: "Regeringen",
  riksdagen: "Riksdagen",
  eu: "EU",
  kommuner: "Kommuner & regioner",
  demokrati: "Demokrati",
  yttrandefrihet: "Yttrandefrihet",
  integritet: "Personlig integritet",
  mansliga_rattigheter: "Mänskliga rättigheter",
  migration: "Migration",
  integration: "Integration",
  religion: "Religion",
  hbtq: "HBTQ",
  jamstalldhet: "Jämställdhet",
  israel_gaza: "Israel–Gaza",
  ryssland_ukraina: "Ryssland–Ukraina",
  kina: "Kina",
  usa: "USA",
  nato: "Nato",
  handelspolitik: "Handelspolitik",
  kultur: "Kultur",
  medier: "Medier",
  sport: "Sport",
  ekonomisk_fordelning: "Ekonomisk fördelning",
  individ_vs_kollektiv: "Individ vs kollektiv",
  marknad_vs_reglering: "Marknad vs reglering",
  kort_vs_langsiktigt: "Kort- vs långsiktigt",
  nationellt_vs_internationellt: "Nationellt vs internationellt",
  teknik_och_ai: "Teknik & AI",
};

export function amneLabel(slug: string): string {
  return AMNEN_LABELS[slug] ?? slug;
}

export const FAKTAKARAKTAR_LABEL: Record<string, string> = {
  nyhet: "Nyhet",
  analys: "Analys",
  opinion: "Opinion",
  referat: "Referat",
};